module.exports = __webpack_public_path__ + "img/public-sale.c37d5033.svg";